import reduxConnector from 'root/src/shared/util/reduxConnector'

import getUserDataSelector from 'root/src/client/logic/api/selectors/getUserDataSelector'
import recordIdSelector from 'root/src/client/logic/api/selectors/recordIdSelector'

import canApproveProjectSelector from 'root/src/client/logic/project/selectors/canApproveProjectSelector'
import canEditProjectDetailsSelector from 'root/src/client/logic/project/selectors/canEditProjectDetailsSelector'
import canRejectActiveProjectSelector from 'root/src/client/logic/project/selectors/canRejectActiveProjectSelector'
import canRejectProjectSelector from 'root/src/client/logic/project/selectors/canRejectProjectSelector'
import createdSelector from 'root/src/client/logic/project/selectors/createdSelector'
import timeLeftSelector from 'root/src/client/logic/project/selectors/timeLeftSelector'
import favoritesAmountSelector from 'root/src/client/logic/project/selectors/favoritesAmountSelector'
import favoritesProcessingSelector from 'root/src/client/logic/project/selectors/favoritesProcessingSelector'
import myFavoritesSelector from 'root/src/client/logic/project/selectors/myFavoritesSelector'
import myPledgeSelector from 'root/src/client/logic/project/selectors/myPledgeSelector'
import pledgeAmountSelector from 'root/src/client/logic/project/selectors/pledgeAmountSelector'
import pledgersSelector from 'root/src/client/logic/project/selectors/pledgersSelector'
import projectAssigneesSelector from 'root/src/client/logic/project/selectors/projectAssigneesSelector'
import projectDescriptionSelector from 'root/src/client/logic/project/selectors/projectDescriptionSelector'
import projectGameImageSquareSelector from 'root/src/client/logic/project/selectors/projectGameImageSquareSelector'
import projectGamesSelector from 'root/src/client/logic/project/selectors/projectGamesSelector'
import projectTitleSelector from 'root/src/client/logic/project/selectors/projectTitleSelector'
import brandProductSelector from 'root/src/client/logic/project/selectors/brandProductSelector'
import sponsorSelector from 'root/src/client/logic/project/selectors/sponsorSelector'
import statusSelector from 'root/src/client/logic/project/selectors/statusSelector'
import projectDeliveriesSelector from 'root/src/client/logic/project/selectors/projectDeliveriesSelector'
import isOneOfAssignesSelector from 'root/src/client/logic/project/selectors/isOneOfAssigneesSelector'
import projectAcceptanceStatusSelector from 'root/src/client/logic/project/selectors/projectAcceptanceStatusSelector'
import recordClickActionErrorSelector from 'root/src/client/logic/project/selectors/recordClickActionErrorSelector'
import isFeaturedDareSelector from 'root/src/client/logic/project/selectors/isFeaturedDareSelector'
import goalProgressSelector from 'root/src/client/logic/project/selectors/goalProgressSelector'
import goalAmountSelector from 'root/src/client/logic/project/selectors/goalAmountSelector'
import isAuthenticatedSelector from 'root/src/client/logic/auth/selectors/isAuthenticated'
import userRejectedDareSelector from 'root/src/client/logic/project/selectors/userRejectedDareSelector'
import projectShareUrlSelector from 'root/src/client/logic/project/selectors/projectShareUrlSelector'
import projectUrlSelector from 'root/src/client/logic/project/selectors/projectUrlSelector'
import isMobileResSelector from 'root/src/client/logic/app/selectors/isMobileResSelector'
import projectCreatorDataSelector from 'root/src/client/logic/project/selectors/projectCreatorDataSelector'
import isBrandUserSelector from 'root/src/client/logic/static/selectors/isBrandUserSelector'

import auditFavorites from 'root/src/client/logic/project/thunks/auditFavorites'
import updateProject from 'root/src/client/logic/project/thunks/updateProject'
import displayModal from 'root/src/client/logic/modal/thunks/displayModal'
import oauthAuthenticate from 'root/src/client/logic/auth/thunks/oauthAuthenticate'
import isTwitchPanelDareSelector from 'root/src/client/logic/project/selectors/isTwitchPanelDareSelector'
import claimSponsoredProject from 'root/src/client/logic/project/thunks/claimSponsoredProject'
import setInput from 'root/src/client/logic/form/thunks/setInput'
import redirectAndPrePopulate from 'root/src/client/logic/app/thunks/redirectAndPrePopulate'
import isAdminSelector from 'root/src/client/logic/auth/selectors/isAdminSelector'
import reportCtaClick from 'root/src/client/logic/project/thunks/reportCtaClick'
import apiRequest from 'root/src/client/logic/api/thunks/apiRequest'
import landingShortUrlSelector
	from 'root/src/client/logic/project/selectors/landingShortUrlSelector'
import campaignIdSelector from 'root/src/client/logic/project/selectors/campaignIdSelector'
import { projectStreamMinutesSelector } from 'root/src/client/logic/project/selectors/projectStreamMinutesSelector'
import { projectDareLevelMinutesSelector } from 'root/src/client/logic/project/selectors/projectDareLevelSelector'
import { projectProductAmountSelector } from 'root/src/client/logic/project/selectors/projectProductAmountSelector'
import { communityReviewDetailsSelector } from 'root/src/client/logic/project/selectors/communityReviewDetailsSelector'
import { isSubmittable } from 'root/src/client/logic/project/selectors/isSubmittableSelector'

export default reduxConnector(
	[
		['assignees', projectAssigneesSelector],
		['canApproveProject', canApproveProjectSelector],
		['canEditProjectDetails', canEditProjectDetailsSelector],
		['canRejectActiveProject', canRejectActiveProjectSelector],
		['canRejectProject', canRejectProjectSelector],
		['created', createdSelector],
		['timeLeft', timeLeftSelector],
		['favoritesAmount', favoritesAmountSelector],
		['favoritesProcessing', favoritesProcessingSelector],
		['gameImage', projectGameImageSquareSelector],
		['games', projectGamesSelector],
		['isAuthenticated', isAuthenticatedSelector],
		['isAdmin', isAdminSelector],
		['myFavorites', myFavoritesSelector],
		['myPledge', myPledgeSelector],
		['pledgeAmount', pledgeAmountSelector],
		['goalProgress', goalProgressSelector],
		['pledgers', pledgersSelector],
		['projectId', recordIdSelector],
		['projectDescription', projectDescriptionSelector],
		['projectTitle', projectTitleSelector],
		['brandProduct', brandProductSelector],
		['projectProductAmount', projectProductAmountSelector],
		['sponsor', sponsorSelector],
		['status', statusSelector],
		['userData', getUserDataSelector],
		['projectDeliveries', projectDeliveriesSelector],
		['isOneOfAssignees', isOneOfAssignesSelector],
		['projectAcceptanceStatus', projectAcceptanceStatusSelector],
		['recordClickActionError', recordClickActionErrorSelector],
		['goalAmount', goalAmountSelector],
		['userRejectedDare', userRejectedDareSelector],
		['projectShareUrl', projectShareUrlSelector],
		['projectUrl', projectUrlSelector],
		['isMobileRes', isMobileResSelector],
		['isTwitchPanelDare', isTwitchPanelDareSelector],
		['creatorData', projectCreatorDataSelector],
		['isBrandUser', isBrandUserSelector],
		['isFeatured', isFeaturedDareSelector],
		['landingShortUrl', landingShortUrlSelector],
		['campaignId', campaignIdSelector],
		['projectStreamMinutes', projectStreamMinutesSelector],
		['level', projectDareLevelMinutesSelector],
		['communityReviewDetails', communityReviewDetailsSelector],
		['isSubmittable', isSubmittable],
	],
	[
		['auditFavorites', auditFavorites],
		['updateProject', updateProject],
		['displayModal', displayModal],
		['oauthAuthenticate', oauthAuthenticate],
		['claimSponsoredProject', claimSponsoredProject],
		['setInput', setInput],
		['redirectAndPrePopulate', redirectAndPrePopulate],
		['reportCtaClick', reportCtaClick],
		['apiRequest', apiRequest],
	],
)
